export const getIsLoading = ( state ) => {
    return state.isLoading;
}
